import { get, post, login as lgn, forgetPassword as fps } from './Y4Api';
import _ from 'lodash';
import y, { formatByNamedArgs } from 'y4/Utils';
import { setAuthentication } from 'y4/Authentication';

function isProduction() {
  return process.env.NODE_ENV == 'production';
}

function isDevelopment() {
  return process.env.NODE_ENV == 'development';
}

async function getConfigImageUrl(key) {
  const d = await getSingleConfig(key);
  if (d) return d.imageUrl;
  return null;
}

async function getSingleConfig(key) {
  const cs = await getConfig(key);
  if (cs) {
    var d = cs[0];
    if (d.imageUrl) {
      d.imageUrl = process.env.REACT_APP_FILE_ROOT + '/' + d.imageUrl;
    }
    return d;
  }
  return null;
}

async function getConfigByCode(code, key = null) {
  const rt = await get('WebUiFalcon', 'GetConfig', {
    code,
    key,
    corp: y.getCorpCode()
  });
  if (rt && rt.isOk() && !_.isEmpty(rt.data)) {
    return rt.data;
  }
  return null;
}

/**
 * Get configs by key. Each config object like:
 *
 * {
 *   "key": "LandingProcess",
 *   "code": "编码",
 *   "title": "标题",
 *   "caption": "说明",
 *   "url": "连接",
 *   "imageUrl": null,
 *   "videoUrl": null,
 *   "content": "数据",
 *   "extension": null,
 *   "date": "12/13/2024 15:24:33",
 *   "remark": null
 * }
 *
 * @param {*} key
 * @returns An array of config
 */
async function getConfig(key, sort = 'desc') {
  const rt = await get('WebUiFalcon', 'GetConfig', {
    key,
    sort,
    corp: y.getCorpCode()
  });
  if (rt && rt.isOk() && !_.isEmpty(rt.data)) {
    return rt.data;
  }
  return null;
}

/**
 * Find a config in configs by key. Then to get image url from config object
 * @param {*} configs
 * @param {*} key
 * @returns
 */
function getConfigFromConfigsByKey(configs, key) {
  if (_.isEmpty(configs)) return null;
  return _.find(configs, ['key', key]);
}

/**
 * Find a config in configs by key. Then to get image url from config object
 * @param {*} configs
 * @param {*} key
 * @returns
 */
function getImageUrlFromConfigsByKey(configs, key) {
  if (_.isEmpty(configs)) return null;
  const c = _.find(configs, ['key', key]);
  return getImageUrlOfConfig(c);
}

/**
 * Get image url from a config object
 * Take image url from imageUrl first, and if don't find it, take it from extension.imageUrl
 * @param {*} config
 * @returns
 */
function getImageUrlOfConfig(config) {
  if (config) {
    if (config.imageUrl) return getEffectiveUrl(config.imageUrl);
    return getEffectiveUrl(_.get(config, 'extension.imageUrl'));
  } else {
    return null;
  }
}

function getEffectiveUrl(url) {
  if (_.isEmpty(url)) return null;
  if (_.startsWith(url, 'http')) {
    return url;
  } else if (_.startsWith(url, '/')) {
    return process.env.REACT_APP_FILE_ROOT + url;
  } else {
    return process.env.REACT_APP_FILE_ROOT + '/' + url;
  }
}

async function getMenu(code) {
  const rt = await get('WebUiFalcon', 'GetMenu', {
    system: process.env.REACT_APP_Y4_SUB_SYSTEM,
    kind: `menu`,
    department_code: code
  });
  if (rt && rt.isOk() && !_.isEmpty(rt.data)) {
    return rt.data;
  }
  return null;
}

async function getQuickLink(kind) {
  const rt = await get('WebUiFalcon', 'GetQuickLink', {
    system: process.env.REACT_APP_Y4_SUB_SYSTEM,
    kind,
    department_code: ''
  });
  if (rt && rt.isOk() && !_.isEmpty(rt.data)) {
    return rt.data;
  }
  return null;
}
/**
 * Add current page some info at get form
 * @param {*} code
 * @param {*} params
 * @returns
 */
async function getForm(code, params = {}) {
  const k = y.md5(code + JSON.stringify(params)) + '_f';
  const json = y.getSessionItem(k);
  if (json) {
    return JSON.parse(json);
  }
  const rt = await get('WebUiFalcon', 'GetForm', {
    ...params,
    code
  });
  if (rt && rt.isOk()) {
    y.setSessionItem(k, JSON.stringify(rt.data));
    return rt.data;
  }
  return null;
}

/**
 *
 * @returns
 */
async function getRoute(code) {
  const rt = await get('WebUiFalcon', 'GetRoute', {
    system: process.env.REACT_APP_Y4_SUB_SYSTEM,
    kind: '%',
    department_code: code
  });
  if (rt && rt.isOk() && !_.isEmpty(rt.data)) {
    return rt.data;
  }
  return null;
}

async function getMenuAndRoute(code) {
  const m = await getMenu(code);
  const r = await getRoute(code);
  return { menu: m, route: r };
}

async function checkPrivilegeByToken(route, token) {
  return await post(
    'WebUiFalcon',
    'CheckPrivilegeByToken',
    {
      system: process.env.REACT_APP_Y4_SUB_SYSTEM,
      route: route,
      kind: '%', //Same with getRoute
      token: token
    },
    { route: route }
  );
}

/**
 *
 * @returns
 */
async function getTranslation() {
  const rt = await get('WebUiFalcon', 'GetTranslation', {});
  if (rt && rt.isOk() && !_.isEmpty(rt.data)) {
    return rt.data;
  }
  return null;
}

/**
 *
 * @param {*} code
 * @returns
 */
async function getCorp(code) {
  const rt = await get('WebUiFalcon', 'GetCorp', { code });
  if (rt && rt.isOk() && !_.isEmpty(rt.data)) {
    return rt.data;
  }
  return null;
}

/**
 * Load data from back end before react
 * @returns
 */
async function init() {
  //Get all translation
  const translation = await getTranslation();

  //Get corp info by root path
  const corp = await getCorp(y.getCorpCode());

  const rps = (t, ns, key, value) => {
    if (value) {
      const ls = t[ns];
      if (ls) {
        ls[key] = value;
      }
    }
  };

  //Replace translation by corp info
  if (corp.code != 'y4') {
    for (var lng in translation) {
      const t = translation[lng];

      rps(t, 'translation', 'Browser title', corp['name']);
      rps(
        t,
        'translation',
        'Thank you for selected AllyWorld',
        corp['copyright']
      );
      rps(t, 'translation', 'System name', corp['sortName']);
      rps(t, 'auth', 'System name', corp['sortName']);
      rps(t, 'auth', 'System description', corp['description']);
      rps(t, 'auth', 'Read our terms and conditions', corp['welcome']);
      rps(t, 'auth', 'Thanks for using Y4.', corp['goodbye']);
    }
  }

  //Get all route url
  //const routes = await getRoute();
  //Now change to set route after login
  const routes = [];
  return { routes, translation, corp };
}

/**
 *
 * @param {*} team
 * @param {*} corp
 * @param {*} type
 * @param {*} user
 * @param {*} password
 * @param {*} remember
 * @param {*} from
 * @param {*} setGlobalData
 * @param {*} t
 */
function login(
  team,
  corp,
  type,
  user,
  password,
  remember,
  from,
  setGlobalData,
  t
) {
  lgn(team, corp, type, user, password).then(rt => {
    if (rt.isOk()) {
      //get menu for current user
      getMenuAndRoute(rt.data.department).then(mar => {
        const al = rt.data.afterLogin ?? {};
        delete rt.data.afterLogin;
        if (!al.to) al.to = from;
        y.setSessionItem(y.md5('ActionAfterLogin'), JSON.stringify(al));

        //show message after lgoin
        if (rt.message) {
          //show warn message
          y.toastWarn(rt.message);
        } else {
          //show success message
          const message = t(`login_success`);
          const formated = formatByNamedArgs(message, {
            email: rt.data.userName
          });
          y.toastSuccess(formated);
        }

        //set JWT token to local
        setAuthentication(corp, rt.data, remember);

        //save menu to global data
        setGlobalData({
          authentication: rt.data,
          ...mar
        });
      });
    } else {
      const message = rt.message ? rt.message : t(`login_${rt.code}`);
      const formated = formatByNamedArgs(message, { email: user });
      y.toastWarn(formated);
    }
  });
}

function forgetPassword(team, corp, type, email, t, navigate) {
  fps(team, corp, type, email).then(rt => {
    if (rt.isOk()) {
      const message = rt.message ? rt.message : t('forget_password_success');
      const formated = formatByNamedArgs(message, { email: email });
      y.toastSuccess(formated);
      if (rt.data && rt.data.navigateTo) {
        navigate(rt.data.navigateTo);
      }
    } else {
      const message = rt.message ? rt.message : t(`forget_password_${rt.code}`);
      const formated = formatByNamedArgs(message, { email: email });
      y.toastWarn(formated);
    }
  });
}

export {
  getConfig,
  getSingleConfig,
  getConfigImageUrl,
  getConfigFromConfigsByKey,
  getImageUrlFromConfigsByKey,
  getImageUrlOfConfig,
  getConfigByCode,
  getEffectiveUrl,
  isProduction,
  isDevelopment,
  getMenu,
  getMenuAndRoute,
  getQuickLink,
  getForm,
  checkPrivilegeByToken,
  init,
  login,
  forgetPassword
};
